import { useCallback } from 'react';
// @mui
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hook';
// components
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Iconify from 'src/components/iconify';
// utils
import { crm_keys } from 'src/utils/crm-commons';

// ----------------------------------------------------------------------

export default function AddPopover() {
  // Hooks
  const popover = usePopover();
  const router = useRouter();

  const handleClick = useCallback((value) => {
    router.push(paths.dashboard.crm.new(value));
    popover.onClose();
  }, []);

  return (
    <>
      <IconButton size='small' onClick={popover.onOpen}>
        <Iconify sx={{ backgroundColor: 'default' }} icon='ic:round-add' width={27} />
      </IconButton>
      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 200, p: 0 }}>
        <Typography ml={1.9} mt={1.2} mb={0.6} variant='subtitle2' color='text.secondary'>Create Records</Typography>
        {crm_keys.map((crmKey) => (
          <MenuItem
            key={crmKey.value + crmKey.about}
            onClick={() => handleClick(crmKey.pluralLowerCase)}
            sx={{ pl: 2 }}
          >
            New {crmKey.singular}
          </MenuItem>
        ))}
      </CustomPopover>
    </>
  );
}
